import {
    AcquireHealthCardNumberState,
    ToggleShowPostalCodeConfirmationModalAction,
    ToggleValidationMessageVisibilityAction,
    IncrementNumberOfSubmitAttemptsAction,
    ChangeValidationPostalCodeValueAction,
    ChangeHealthCardNumberAction,
    SubmitButtonDisabledStatusAction,
    SelectHealthCardAcquiringModeAction,
    ChangeHealthCardMaskLocationAction
} from "./type";
import { initialState } from './reducer';
import { LoadClinicInformationAction } from "../ClinicInformation/type";

/**
 * @name resetAcquireMethodDataHandler
 * @export
 * @param {AcquireHealthCardNumberState} state
 * @returns {AcquireHealthCardNumberState}
 */
export function resetAcquireMethodDataHandler(state: AcquireHealthCardNumberState): AcquireHealthCardNumberState {
    return Object.assign({}, initialState, { acquiringMode: state.acquiringMode });
}

/**
 * @name selectHealthCardAcquiringModeHandler
 * @export
 * @param {AcquireHealthCardNumberState} state
 * @param {SelectHealthCardAcquiringModeAction} action
 * @returns {AcquireHealthCardNumberState}
 */
export function selectHealthCardAcquiringModeHandler(state: AcquireHealthCardNumberState, action: SelectHealthCardAcquiringModeAction): AcquireHealthCardNumberState {
    return Object.assign({}, state, { acquiringMode: action.payload.method });
}

/**
 * @name submitButtonDisabledStatusHandler
 * @export
 * @param {AcquireHealthCardNumberState} state
 * @param {SubmitButtonDisabledStatusAction} action
 * @returns {AcquireHealthCardNumberState}
 */
export function submitButtonDisabledStatusHandler(state: AcquireHealthCardNumberState, action: SubmitButtonDisabledStatusAction): AcquireHealthCardNumberState {
    return Object.assign({}, state, { isSubmitButtonActive: action.payload.isSubmitButtonActive });
}

/**
 * @name changeHealthCardNumberHandler
 * @export
 * @param {AcquireHealthCardNumberState} state
 * @param {ChangeHealthCardNumberAction} action
 * @returns {AcquireHealthCardNumberState}
 */
export function changeHealthCardNumberHandler(state: AcquireHealthCardNumberState, action: ChangeHealthCardNumberAction): AcquireHealthCardNumberState {
    return Object.assign({}, state, { healthCardNumber: action.payload.healthCardNumber, isSubmitButtonActive: action.payload.healthCardNumber.replace(/_/g, "").replace(/\s/g, "").length !== 12 });
}

/**
 * @name changeValidationPostalCodeValueHandler
 * @export
 * @param {AcquireHealthCardNumberState} state
 * @param {ChangeValidationPostalCodeValueAction} action
 * @returns {AcquireHealthCardNumberState}
 */
export function changeValidationPostalCodeValueHandler(state: AcquireHealthCardNumberState, action: ChangeValidationPostalCodeValueAction): AcquireHealthCardNumberState {
    return Object.assign({}, state, { postalCodeEntered: action.payload.postalCode.replace(/_/g, "").replace(/\s/g, "") });
}

/**
 * @name incrementNumberOfSubmitAttemptsHandler
 * @export
 * @param {AcquireHealthCardNumberState} state
 * @param {IncrementNumberOfSubmitAttemptsAction} action
 * @returns {AcquireHealthCardNumberState}
 */
export function incrementNumberOfSubmitAttemptsHandler(state: AcquireHealthCardNumberState, action: IncrementNumberOfSubmitAttemptsAction): AcquireHealthCardNumberState {
    return Object.assign({}, state, { [action.payload.fieldType]: state[action.payload.fieldType] + 1 });
}

/**
 * @name toggleValidationMessageVisibilityHandler
 * @export
 * @param {AcquireHealthCardNumberState} state
 * @param {ToggleValidationMessageVisibilityAction} action
 * @returns {AcquireHealthCardNumberState}
 */
export function toggleValidationMessageVisibilityHandler(state: AcquireHealthCardNumberState, action: ToggleValidationMessageVisibilityAction): AcquireHealthCardNumberState {
    const newState = state;
    if (action.payload.isValidationMessageVisible) {
        newState.healthCardNumber = "";
        newState.postalCodeEntered = "";
    }
    newState[action.payload.fieldType] = action.payload.isValidationMessageVisible;
    return Object.assign({}, state, newState);
}

/**
 * @name toggleShowPostalCodeConfirmationModalHandler
 * @export
 * @param {AcquireHealthCardNumberState} state
 * @param {ToggleShowPostalCodeConfirmationModalAction} action
 * @returns {AcquireHealthCardNumberState}
 */
export function toggleShowPostalCodeConfirmationModalHandler(state: AcquireHealthCardNumberState, action: ToggleShowPostalCodeConfirmationModalAction): AcquireHealthCardNumberState {
    return Object.assign({}, state, { showPostalCodeConfirmationModal: action.payload.showPostalCodeModal });
}

export function changeHealthCardMaskLocationHandler(state: AcquireHealthCardNumberState, action: ChangeHealthCardMaskLocationAction): AcquireHealthCardNumberState {
    return Object.assign({}, state, { maskCountry: action.payload.country, maskRegion: action.payload.region, healthCardNumber: "" });
}

export function loadClinicInformationHandler(state: AcquireHealthCardNumberState, action: LoadClinicInformationAction): AcquireHealthCardNumberState {
    const healthCardInfo = action.payload.healthCards.firstOrDefault();

    return Object.assign({}, state, {
        maskCountry: healthCardInfo ? healthCardInfo.countryCode : "",
        maskRegion: healthCardInfo ? healthCardInfo.regionCode : "",
    });
}


// WEBPACK FOOTER //
// ./src/store/AcquireHealthCardNumber/handlers.ts